export const PRICE_FEATURE_KEY = 'price';
